import { Container, ContainerProps } from "@mui/material";

interface TextFieldContainerProps extends ContainerProps {};

function TextFieldContainer(props: TextFieldContainerProps) {
    return <Container className="textfield-container" {...props}>{props.children}</Container>
};

export default TextFieldContainer;